/*
 * IMPORTS
 */
import React from 'react' // Npm: react.js library.
import PropTypes from 'prop-types' // Npm: react.js library.
import { toast } from 'react-hot-toast' // Npm: React hot toast.
import { connect } from 'react-redux' // Npm: React Redux for state management.
import { useMutation } from '@apollo/client' // Npm: Apollo client.


/*
 * PACKAGES
 */
import DeleteCard from 'components/DeleteCard'


/*
 * GRAPHS
 */
import EntityDeleteMutation from './__mutation__/index.entity.delete.mutation'
import _ from 'lodash'


/*
 * OBJECTS
 */
const Index = ({ passOn, onClose }) => {
  // Hook assignment.
  const [MutationEntityDelete, MutationEntityDeleteResponse] = useMutation(EntityDeleteMutation)

  // Return Component.
  return (
    <DeleteCard onClose={onClose} disabled={MutationEntityDeleteResponse.loading} onConfirm={() =>
      MutationEntityDelete({
        'variables': {
          'entityIds': [passOn?.entityId]
        }
      }).then(i => {
        // Style Guide.
        toast(_.first(i?.data?.EntityDelete)?.message)

        // Report success.
        return onClose?.()
      }).catch(() =>
        // Style Guide.
        toast('Something went wrong please try after some time.'))} isLoading={MutationEntityDeleteResponse.loading} />
  )
}


/*
 * PROPTYPES
 */
Index.propTypes = {
  'passOn': PropTypes.object,
  'onClose': PropTypes.func
}


/*
 * REDUX
 */
const _MapStateToProps = __state => ({ 'passOn': __state.PassOn })


/*
 * EXPORT
 */
export default connect(_MapStateToProps)(Index)
